module.exports = __webpack_public_path__ + "static/media/location-to-location-icon.63e3652b.svg";